import { snakeToTitleCase } from 'lib/helpers/utility';
import { PORTRAIT_MAX_COLUMNS } from 'lib/helpers/pdf/tableExport/lib/constants';

export const getInitialValues = ({ title, name, columns }) => {
  const visibleFields = columns
    .filter((col) => !col.hide || col.alwaysExport)
    .map((col) => col.field);
  const hasHiddenColumns = visibleFields.length > 0 && visibleFields.length < columns.length;

  return {
    title: snakeToTitleCase(title || name),
    export_type: [],
    orientation: columns.length > PORTRAIT_MAX_COLUMNS ? 'landscape' : 'portrait',
    export_columns: hasHiddenColumns ? ['custom'] : ['all'],
    selected_columns: hasHiddenColumns ? visibleFields : [],
    selected_parent_columns: hasHiddenColumns ? visibleFields : [],
    export_data: 'summary',
    // Default to the page the user is looking at: the full dataset can be hundreds of
    // thousands of rows, so exporting everything is the deliberate choice, not the accident.
    export_scope: 'current'
  };
};
